export default __webpack_public_path__ + "static/media/M_Meia.56640db5.svg";